// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"a57fdd09","541":"8688104c","554":"97b778c3","913":"e646e713"}[chunkId] + ".chunk.js";
};